import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKEDIN_JOBS_URL = "https://www.linkedin.com/company/switchtt/jobs";

const internalNav = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 md:h-24 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <img src="/logo.png" alt="Switch Tech Talent" className="h-10 md:h-12 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink
            to="/"
            end
            data-testid="nav-home"
            className={({ isActive }) =>
              `font-mono text-[11px] uppercase tracking-[0.2em] transition-colors ${
                isActive ? "text-[#3B82F6]" : "text-white/70 hover:text-white"
              }`
            }
          >
            Home
          </NavLink>
          <a
            href={LINKEDIN_JOBS_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-live-roles"
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/70 hover:text-white transition-colors inline-flex items-center gap-1.5"
          >
            Live Roles <ArrowUpRight size={12} />
          </a>
          {internalNav.slice(1).map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-mono text-[11px] uppercase tracking-[0.2em] transition-colors ${
                  isActive ? "text-[#3B82F6]" : "text-white/70 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="header-cta-submit-cv"
          className="hidden md:inline-flex btn-volt px-5 py-2.5 text-xs tracking-wider uppercase"
        >
          Submit CV
        </Link>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
          aria-label="toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black">
          <div className="px-6 py-6 flex flex-col gap-5">
            <NavLink to="/" end onClick={() => setOpen(false)} className="font-mono text-sm uppercase tracking-widest text-white/80" data-testid="mobile-nav-home">
              Home
            </NavLink>
            <a
              href={LINKEDIN_JOBS_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              className="font-mono text-sm uppercase tracking-widest text-white/80 inline-flex items-center gap-2"
              data-testid="mobile-nav-live-roles"
            >
              Live Roles <ArrowUpRight size={14} />
            </a>
            {internalNav.slice(1).map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="font-mono text-sm uppercase tracking-widest text-white/80"
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-volt px-4 py-3 text-center text-xs uppercase tracking-wider" data-testid="mobile-cta">
              Submit CV
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
